// extracted by mini-css-extract-plugin
export var bgImage = "_2g-w";
export var body = "_2g-v";
export var buttonBar = "_2g-5";
export var card = "_2g-0";
export var center = "_2g-10";
export var chevron = "_2g-14";
export var closeButton = "_2g-12";
export var collapseHeader = "_2g-6";
export var collapseIcon = "_2g-c";
export var collapseSection = "_2g-a";
export var collapseTitle = "_2g-9";
export var collapseTrigger = "_2g-7";
export var collapsed = "_2g-b";
export var dark = "_2g-1";
export var expandableCard = "_2g-15";
export var expandableCardTitle = "_2g-13";
export var grid = "_2g-4";
export var header = "_2g-e";
export var headerContainer = "_2g-d";
export var headerSubtitle = "_2g-j";
export var headerTitle = "_2g-f";
export var inherit = "_2g-8";
export var large = "_2g-h";
export var left = "_2g-11";
export var linkColor = "_2g-16";
export var medium = "_2g-i";
export var noPadding = "_2g-3";
export var outlined = "_2g-o";
export var scrollable = "_2g-2";
export var section = "_2g-n";
export var sectionHeader = "_2g-r";
export var selected = "_2g-p";
export var separator = "_2g-q";
export var subsection = "_2g-s";
export var subtitle = "_2g-t";
export var subtotalCollapseHeader = "_2g-x";
export var subtotalCollapseHeaderTitle = "_2g-y";
export var subtotalItem = "_2g-z";
export var table = "_2g-k";
export var tableCell = "_2g-m";
export var tableHeader = "_2g-l";
export var title = "_2g-u";
export var titleFullWidth = "_2g-g";